import {useSyncExternalStore} from 'react';

import {useAssertedContext} from '@pexip/media-components';

import {RegistrationContext} from '../contexts/registration.context';
import {
    registrationStepSignal,
    registrationStatusSignal,
    registrationErrorSignal,
    registrationIdpsSignal,
    registrationIncomingCallSignal,
} from '../signals/Registration.signals';

export const useRegistrationContext = () =>
    useAssertedContext(RegistrationContext);

export const useRegistrationStep = () => {
    const registration = useRegistrationContext();
    return useSyncExternalStore(
        registrationStepSignal.add,
        registration.getStep,
    );
};

export const useRegistrationStatus = () => {
    const registration = useRegistrationContext();
    return useSyncExternalStore(
        registrationStatusSignal.add,
        registration.getStatus,
    );
};

export const useRegistrationError = () => {
    const registration = useRegistrationContext();
    return useSyncExternalStore(
        registrationErrorSignal.add,
        registration.getError,
    );
};

export const useRegistrationIdps = () => {
    const registration = useRegistrationContext();
    return useSyncExternalStore(
        registrationIdpsSignal.add,
        registration.getIdps,
    );
};

export const useIsRegistered = () => {
    const registration = useRegistrationContext();
    return useSyncExternalStore(
        registrationStatusSignal.add,
        () => registration.getStatus() === 'registered',
    );
};

export const useRegistrationAlias = () => {
    const registration = useRegistrationContext();
    return useSyncExternalStore(
        registrationStatusSignal.add,
        registration.getAlias,
    );
};

export const useIncomingCall = () => {
    const registration = useRegistrationContext();
    return useSyncExternalStore(registrationIncomingCallSignal.add, () =>
        registration.getIncomingCall(),
    );
};
